import { useEffect, useState } from 'react';
import appStoreBadge from '../img/Store=App Store, Type=Dark, Language=English.svg';
import playStoreBadge from '../img/Store=Google Play, Type=Dark, Language=English.svg';

type Platform = 'ios' | 'android' | 'mac' | 'windows' | 'other';

const appStoreUrl = process.env.REACT_APP_APP_STORE_URL;
const playStoreUrl = process.env.REACT_APP_PLAY_STORE_URL;

function detectPlatform(userAgent: string): Platform {
  const ua = userAgent.toLowerCase();
  if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
    return 'ios';
  }
  if (ua.includes('android')) {
    return 'android';
  }
  if (ua.includes('mac os x') || ua.includes('macintosh')) {
    return 'mac';
  }
  if (ua.includes('windows nt') || ua.includes('win64') || ua.includes('win32')) {
    return 'windows';
  }
  return 'other';
}

export default function DownloadRedirect() {
  const [platform, setPlatform] = useState<Platform>('other');
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const nextPlatform = detectPlatform(window.navigator.userAgent ?? '');
    setPlatform(nextPlatform);

    const targetUrl =
      nextPlatform === 'ios' || nextPlatform === 'mac'
        ? appStoreUrl
        : nextPlatform === 'android'
        ? playStoreUrl
        : null;

    if (targetUrl) {
      setRedirecting(true);
      window.location.replace(targetUrl);
    }
  }, []);

  const linksConfigured = Boolean(appStoreUrl || playStoreUrl);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <div>
        <h1 style={{ margin: '1rem', fontWeight: 500}}>Download Happy Tail Tracker</h1>
        {redirecting ? (
          <p>Redirecting you to the correct app store…</p>
        ) : (
          <p>
            {linksConfigured
              ? 'Choose your platform to download the app.'
              : 'App store links are not configured yet.'}
          </p>
        )}

        <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {appStoreUrl && (
            <a
              href={appStoreUrl}
              style={{
                display: 'inline-block',
                borderRadius: '0.75rem',
                overflow: 'hidden',
                textDecoration: 'none',
                boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
              }}
            >
              <img
                src={appStoreBadge}
                alt="Download on the App Store"
                style={{ display: 'block', height: '56px', width: 'auto' }}
              />
            </a>
          )}
          {playStoreUrl && (
            <a
              href={playStoreUrl}
              style={{
                display: 'inline-block',
                borderRadius: '0.75rem',
                overflow: 'hidden',
                textDecoration: 'none',
                boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
              }}
            >
              <img
                src={playStoreBadge}
                alt="Get it on Google Play"
                style={{ display: 'block', height: '56px', width: 'auto' }}
              />
            </a>
          )}
        </div>

        {!linksConfigured && (
          <p style={{ marginTop: '1rem', color: '#c0392b' }}>
            Add REACT_APP_APP_STORE_URL and REACT_APP_PLAY_STORE_URL to your environment.
          </p>
        )}

        {!redirecting && linksConfigured && (
          <p style={{ marginTop: '1rem', color: '#555' }}>
            {platform === 'other'
              ? 'We could not detect your device. Please choose a link above.'
              : 'If nothing happens, use the link above to continue.'}
          </p>
        )}
      </div>
    </div>
  );
}
